import type { ModuleTagEntry } from './index';

/** Patient Study module tags. */
export const tags: ModuleTagEntry[] = [
  'PatientAge',
  'PatientSize',
  'PatientSex',
  'PatientWeight',
];
